import axios from 'axios'
import store from './store'

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_ENDPOINT
})

instance.defaults.headers.common = {
	'Accept': 'application/json',
	'Content-Type': 'application/json'
}

instance.interceptors.response.use(null, (error) => {
	if(error.response.data.message == 'Unauthenticated.') {
		return store.dispatch('attemptRefresh').then((response) => {
			if(response == 'success') {
				error.config.headers['Authorization'] = 'Bearer ' + store.getters.token
				return axios.request(error.config)
			}
		})
	}
	return Promise.reject(error)
})

export default instance